import AppBar from '@material-ui/core/AppBar';
import AsyncSelect from 'react-select/async';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Checkbox from '@material-ui/core/Checkbox';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import React from 'react';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import TextField from '@material-ui/core/TextField';

import { CircularProgress } from '@material-ui/core';
import { RpcLogs } from './WildSky/RpcLogs';
import { MapComments } from './WildSky/MapComments';
import { CheckGitlabAccess } from './WildSky/CheckGitlabAccess';
import { UserBackupData } from './WildCastle/UserBackupData';
import { RemoteButton } from './RemoteButton';
import { JsonView } from './WildSky/JsonView';
import { default as LazySelect } from './ReactProtos/CellSelect';

function getStateFromHash() {
    const text = window.location.hash;
    if (!text) {
        return {};
    }
    return JSON.parse(decodeURIComponent(text.substring(1)));
}

function setStateToHash(value) {
    window.location.hash = encodeURIComponent(JSON.stringify(value));
}

async function loadWildSkyData(file) {
    const response = await fetch(`/api/gitlab/file/get?path=${encodeURIComponent(file)}&branch=master&repo=data`);
    const result = await response.json();
    return JSON.parse(atob(result.content));
}

class GenericCollectionComponent extends React.PureComponent {
    state = {
        loading: true,
        inventory: null,
        error: null,
    }
    componentDidMount() {
        fetch(`/api/data/get/${this.props.collection}/${this.props.userId}`)
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ loading: false, error: result.error });
                } else {
                    this.setState({ loading: false, inventory: result.result });
                }
            });
    }

    render() {
        if (this.state.loading) {
            return <div>Loading...</div>;
        }
        if (this.state.error) {
            return <div>{this.state.error}</div>;
        }
        return (
            <div>
                <JsonView value={this.state.inventory} />
            </div>
        );
    }
}

GenericCollectionComponent.propTypes = {
    userId: PropTypes.string.isRequired,
    collection: PropTypes.string.isRequired,
};

function Inventory(props) {
    return <GenericCollectionComponent {...props} collection={"user_inventory"} />;
}

function Cards(props) {
    return <GenericCollectionComponent {...props} collection={"cards"} />;
}

function Achievement(props) {
    return <GenericCollectionComponent {...props} collection={"achievement"} />;
}

function MapEvent(props) {
    return <GenericCollectionComponent {...props} collection={"map_event"} />;
}

function TournamentPlayerStates(props) {
    return <GenericCollectionComponent {...props} collection={"tournament_player_states"} />;
}

function Gacha(props) {
    return <GenericCollectionComponent {...props} collection={"gacha"} />;
}

class Subscriptions extends React.PureComponent {
    state = {
        revision: 0,
        key: null,
        sending: false,
        showConfirmDialog: false,
        error: null,
    };

    loadSubscriptionOptions = () => {
        return loadWildSkyData("SubscriptionData.json").then(data => {
            return data.subscriptions.map(subscription => ({ label: subscription.key, value: subscription.key }));
        });
    }

    onChangeSubscriptionKey = value => {
        this.setState({ key: value });
    }

    showConfirmDialog = () => {
        this.setState({ showConfirmDialog: true });
    }

    closeConfirmDialog = () => {
        this.setState({ showConfirmDialog: false });
    }

    startSend = () => {
        this.setState({ sending: true });
        fetch(`/api/data/user/add_subscription/${this.props.userId}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ key: this.state.key.value }),
        })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ sending: false, error: result.error });
                } else {
                    this.setState({ sending: false, showConfirmDialog: false, revision: this.state.revision + 1 });
                }
            });

    }

    render() {
        return (<div>
            <Dialog open={this.state.showConfirmDialog} onClose={this.closeConfirmDialog}>
                <DialogTitle>Give the user {this.state.key && this.state.key.value}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Once you give the user {this.state.key && this.state.key.value}, you cannot take it back. Are you sure?
                        </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={this.closeConfirmDialog}>No</Button>
                    {
                        this.state.sending &&
                        <CircularProgress />
                    }
                    {
                        !this.state.sending &&
                        <Button variant="contained" onClick={this.startSend}>Yes</Button>
                    }
                </DialogActions>
            </Dialog>
            <GenericCollectionComponent key={this.state.revision} {...this.props} collection={"subscriptions"} />
            {
                this.state.error && <span style={{ color: 'red' }}>{this.state.error}</span>
            }
            Subscription to add:
            <AsyncSelect cacheOptions defaultOptions value={this.state.key} onChange={this.onChangeSubscriptionKey} loadOptions={this.loadSubscriptionOptions} />
            <Button onClick={this.showConfirmDialog}>Send</Button>

        </div>);
    }
}

Subscriptions.propTypes = {
    userId: PropTypes.string.isRequired,
};

class InAppPurchase extends React.PureComponent {
    state = {
        pid: '',
        key: Math.random(),
    };

    handleTextField = name => e => {
        this.setState({ [name]: e.target.value });
    }

    startAddProduct = async () => {
        const response = await fetch(`/api/data/iap/add`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body:
                JSON.stringify({
                    uuid: this.props.userId,
                    productId: this.state.pid,
                }),
        });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ key: Math.random() });
        }
    }

    render() {
        return (
            <div>
                <GenericCollectionComponent key={this.state.key} {...this.props} collection={"in_app_purchase"} />
                <RemoteButton name="Add Product" onStart={this.startAddProduct}>
                    Product ID: <input value={this.state.pid} onChange={this.handleTextField('pid')} />
                </RemoteButton>
            </div>
        );
    }
}

InAppPurchase.propTypes = {
    userId: PropTypes.string.isRequired,
};

class UserInfo extends React.PureComponent {
    state = {
        loading: true,
        data: null,
        error: null,
        facebookId: '',
        googleId: '',
        appleId: '',
        userTimeZoneOffset: '',
        timeOffsetInSeconds: 0,
    }
    componentDidMount() {
        this.reload();
    }

    reload() {
        console.assert(this.state.loading);
        fetch(`/api/data/get/user/${this.props.userId}`, { cache: 'no-cache' })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ loading: false, error: result.error });
                } else {
                    this.setState({ loading: false, data: result.result });
                }
            });

    }

    startMarkDev = value => async () => {
        const response = await fetch(`/api/data/user/mark_dev/${this.props.userId}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ disable: !value }),
        });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    startMarkNeedsEventBundle = value => async () => {
        const response = await fetch(`/api/data/user/mark_needs_event_bundle/${this.props.userId}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ enable: value }),
        });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    startForceProductionPatch = value => async () => {
        const response = await fetch(`/api/data/user/force_production_patch/${this.props.userId}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ value }),
        });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    startResetLevel = async () => {
        const response = await fetch(`/api/data/user/reset_level/${this.props.userId}`, { method: 'post' })
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    startMarkCheater = async () => {
        const response = await fetch(`/api/data/user/mark_cheater/${this.props.userId}`, { method: 'post' });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    startUnmarkCheater = async () => {
        const response = await fetch(`/api/data/user/unmark_cheater/${this.props.userId}`, { method: 'post' });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    startDeleteUser = async () => {
        const response = await fetch(`/api/data/user/delete_user/${this.props.userId}`, { method: 'post' });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    startMuteGuildChat = async () => {
        const response = await fetch(`/api/data/user/mute_guild_chat/${this.props.userId}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            }, body: JSON.stringify({ clear_guild_chat_record: this.state.clearGuildChatRecord })
        });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    startUnmuteGuildChat = async () => {
        const response = await fetch(`/api/data/user/unmute_guild_chat/${this.props.userId}`, { method: 'post' });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    startBanMapComment = value => async () => {
        const response = await fetch(`/api/data/user/ban_map_comment/${this.props.userId}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ value })
        });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    startSetFacebookId = async () => {
        const response = await fetch(`/api/data/user/set_facebook_id/${this.props.userId}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            }, body: JSON.stringify({ facebook_id: this.state.facebookId })
        });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    startSetGoogleId = async () => {
        const response = await fetch(`/api/data/user/set_google_id/${this.props.userId}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            }, body: JSON.stringify({ google_id: this.state.googleId })
        });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    startSetAppleId = async () => {
        const response = await fetch(`/api/data/user/set_apple_id/${this.props.userId}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            }, body: JSON.stringify({ apple_id: this.state.appleId })
        });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    startSetUserTimeZoneOffset = async () => {
        const response = await fetch(`/api/data/user/set_user_time_zone_offset/${this.props.userId}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            }, body: JSON.stringify({ user_time_zone_offset: this.state.userTimeZoneOffset })
        });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    startSetTimeOffsetInSeconds = async () => {
        const response = await fetch(`/api/data/user/set_offset_in_seconds/${this.props.userId}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            }, body: JSON.stringify({ time_offset_in_seconds: parseInt(this.state.timeOffsetInSeconds) })
        });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.setState({ loading: true, data: null, error: null });
            this.reload();
        }
    }

    handleTextField = name => e => {
        this.setState({ [name]: e.target.value });
    }

    handleCheckBoxField = name => e => {
        this.setState({ [name]: e.target.checked });
    }

    render() {
        if (this.state.loading) {
            return <div>Loading...</div>;
        }
        if (this.state.error) {
            return <div>{this.state.error}</div>;
        }
        return (
            <div>
                <div>
                    Download <a href={`/api/data/user/save_dat/${this.state.data._id}`}>save.dat</a> to test as the user.
                </div>
                <pre>
                    {JSON.stringify(this.state.data, null, 4)}
                </pre>
                {
                    !this.state.data.dev &&
                    <RemoteButton name="Mark as Dev" title="Mark User as Dev" onStart={this.startMarkDev(true)}>
                        Mark an user as dev. Are you sure?
                    </RemoteButton>
                }
                {
                    this.state.data.dev &&
                    <RemoteButton name="Remove Dev" title="Remove User as Dev" onStart={this.startMarkDev(false)}>
                        Remove dev mark. Are you sure?
                    </RemoteButton>
                }
                {
                    !this.state.data.cheater &&
                    <RemoteButton name="Mark as Cheater" title="Mark User as Cheater" onStart={this.startMarkCheater}>
                        Once you mark an user as Cheater, it cannot be undone. Are you sure?
                    </RemoteButton>
                }
                {
                    this.state.data.cheater &&
                    <RemoteButton name="Unmark as Cheater" onStart={this.startUnmarkCheater}>
                        Unmark this user as cheater.
                    </RemoteButton>
                }
                {
                    !this.state.data.deleted &&
                    <RemoteButton name="Delete User" onStart={this.startDeleteUser}>
                    This will:
                        <ul>
                            <li>purge the user&#39;s personal data (e.g., name, google/apple/facebook id binding, etc.)</li>
                            <li>mark the user for deletion.</li>
                            <li>forbid the user from entering the game.</li>
                        </ul>
                        <b>it cannot be undone.</b> Are you sure?
                    </RemoteButton>
                }
                {
                    !this.state.data.needs_event_bundle &&
                    <RemoteButton name="Mark as Needs Event Bundle" title="Mark as Needs Event Bundle" onStart={this.startMarkNeedsEventBundle(true)}>
                        Mark an user as Needs Event Bundle. Are you sure?
                    </RemoteButton>
                }
                {
                    this.state.data.needs_event_bundle &&
                    <RemoteButton name="Unmark as Needs Event Bundle" title="Unmark as Needs Event Bundle" onStart={this.startMarkNeedsEventBundle(false)}>
                        Unmark an user as Needs Event Bundle. Are you sure?
                    </RemoteButton>
                }
                {
                    this.state.data.dev && !this.state.data.force_production_patch &&
                    <RemoteButton name="Force Production Patch" onStart={this.startForceProductionPatch(true)}>
                        Force the use of production patch instead of master/development version?
                    </RemoteButton>
                }
                {
                    this.state.data.dev && this.state.data.force_production_patch &&
                    <RemoteButton name="Use Master/Development Patch" onStart={this.startForceProductionPatch(false)}>
                        Use master/development version patch?
                    </RemoteButton>
                }
                <RemoteButton name="Set Facebook Id" title="Set facebook Id" onStart={this.startSetFacebookId}>
                    facebook_id: <input value={this.state.facebookId} onChange={this.handleTextField('facebookId')} />
                </RemoteButton>
                <RemoteButton name="Set Google Id" title="Set Google Id" onStart={this.startSetGoogleId}>
                    google_id: <input value={this.state.googleId} onChange={this.handleTextField('googleId')} />
                </RemoteButton>
                <RemoteButton name="Set Apple Id" title="Set Apple Id" onStart={this.startSetAppleId}>
                    apple_id: <input value={this.state.appleId} onChange={this.handleTextField('appleId')} />
                </RemoteButton>
                <RemoteButton name="Set User Time Zone Offset" title="Set User Time Zone Offset" onStart={this.startSetUserTimeZoneOffset}>
                    user_time_zone_offset: <input value={this.state.userTimeZoneOffset} onChange={this.handleTextField('userTimeZoneOffset')} />
                </RemoteButton>
                <RemoteButton name="Set Dev Time Offset" title="Set Dev Time Offset(seconds)" onStart={this.startSetTimeOffsetInSeconds}>
                    time_offset_in_seconds: <input value={this.state.timeOffsetInSeconds} onChange={this.handleTextField('timeOffsetInSeconds')} />
                </RemoteButton>
                {
                    this.state.data.level > 1 &&
                    <RemoteButton name="Reset Level" title="Reset User Level to 1" onStart={this.startResetLevel}>
                        Once you reset a user level, it cannot be undone. Are you sure?
                    </RemoteButton>
                }
                {
                    !this.state.data.ban_map_comment &&
                    <RemoteButton name="Ban Map Comment" onStart={this.startBanMapComment(true)}>
                        Comments of this user will be hidden automatically. Are you sure?
                    </RemoteButton>
                }
                {
                    this.state.data.ban_map_comment &&
                    <RemoteButton name="Unban Map Comment" onStart={this.startBanMapComment(false)}>
                        Allow this user&qutoes;s comment to be visible.
                    </RemoteButton>
                }
                {
                    !this.state.data.mute_guild_chat &&
                    <RemoteButton name="Mute Guild Chat" onStart={this.startMuteGuildChat}>
                        {/*Clear Guild Chat Record: <Checkbox checked={this.state.clearGuildChatRecord} onChange={this.handleCheckBoxField('clearGuildChatRecord')}/>*/}
                    </RemoteButton>
                }
                {
                    this.state.data.mute_guild_chat &&
                    <RemoteButton name="Unmute Guild Chat" onStart={this.startUnmuteGuildChat}>
                    </RemoteButton>
                }
            </div>
        );
    }
}

UserInfo.propTypes = {
    userId: PropTypes.string.isRequired,
};

class MailContent extends React.PureComponent {
    state = {
        loading: true,
        info: null,
    }

    componentDidMount() {
        loadWildSkyData('MailData.json')
            .then(result => {
                this.data = result;
                this.setState({ loading: false });
            });
    }

    render() {
        if (this.state.loading) {
            return <div>loading...</div>;
        }
        return (
            <div>
                <pre>
                    {JSON.stringify(this.data.mailGroups.find(mail => mail.key === this.props.mailKey), null, 4)}
                </pre>
            </div>
        );
    }
}

MailContent.propTypes = {
    mailKey: PropTypes.string.isRequired,
};

class SendMail extends React.PureComponent {
    state = {
        preview: false,
        key: {label: '', value: ''},
        items: [],
        othersText: '',
        others: [],
        sending: false,
    }

    loadEmailSelectOptions = () => {
        return loadWildSkyData('MailData.json').then(data => {
            return data.mailGroups.map(mail => ({ label: mail.key, value: mail.key }));
        });
    }

    loadItemSelectOptions = () => {
        return loadWildSkyData('InventoryData.json').then(data => {
            return data.Items.map(item => ({ label: item.key, value: item.key }));
        });
    }

    addItem = () => {
        this.setState({ items: this.state.items.concat([{ key: {label: '', value: ''}, count: 0 }]) });
    }

    onChangeOthersText = e => {
        this.setState({ othersText: e.target.value });
    }

    onChangeMailKey = value => {
        console.log(value);
        this.setState({ key: value });
    }

    onChangeItemKey = index => value => {
        const items = this.state.items.slice();
        items[index].key = value;
        this.setState({ items });
    }

    onChangeItemCount = index => e => {
        console.log("value is ", e);
        const items = this.state.items.slice();
        items[index].count = e.target.value | 0;
        this.setState({ items });
    }

    onDeleteItem = index => () => {
        const items = this.state.items.slice(0, index).concat(this.state.items.slice(index + 1));
        this.setState({ items });
    }

    onPreview = () => {
        const others = this.state.othersText.split(/[\s,"]+/).filter(s => !!s);
        const users = others.reduce((acc, cur) => {
            acc[cur] = cur;
            return acc;
        }, {});
        this.setState({ preview: true, others: Object.keys(users) });
    }

    onBack = () => {
        this.setState({ preview: false });
    }

    onMail = () => {
        this.setState({ sending: true });
        const mail = {};
        mail.key = this.state.key.value;
        mail.attachments = {
            reward_items: this.state.items.map(item => ({
                Key: item.key.value,
                Value: item.count,
            })),
            reward_claimed: false,
        };
        mail.users = this.state.others;
        fetch(`/api/data/mail/${this.props.userId}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(mail),
        }).then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ sending: false, error: result.error });
                } else {
                    this.setState({ sending: false });
                    if (this.props.onClose) {
                        this.props.onClose();
                    }
                }
            });
    }

    onCancel = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    render() {
        let valid = true;
        let reason = '';
        if (this.state.error) {
            valid = false;
            reason = reason || this.state.error;
        }
        if (!this.state.key || !this.state.key.value) {
            valid = false;
            reason = reason || 'Invalid mail key';
        }
        if (this.state.items.length === 0) {
            valid = false;
            reason = reason || 'No reward item added';
        }
        for (let item of this.state.items) {
            if (!item.key || !item.key.value) {
                valid = false;
                reason = reason || 'There is a reward item missing its key';
            }
            if (item.count <= 0) {
                valid = false;
                reason = reason || 'There is a reward item with 0 count';
            }
        }
        if (this.state.preview || this.state.sending) {
            return <div style={{ width: '100%' }}>
                {!valid && <div style={{ color: 'red' }}>{reason}</div>}
                <div>
                    <h3>Mail Key</h3>
                    {
                        this.state.key &&
                        <MailContent mailKey={this.state.key.value} />
                    }
                </div>
                <div>
                    <h3>Reward Items</h3>
                    {
                        this.state.items.map((item, index) => (
                            <div key={index}>
                                {item.key.value}: {item.count}
                            </div>
                        ))
                    }
                </div>
                <div>
                    <h3>Other Users</h3>
                    <ul>
                        {this.state.others.map(o => <li key={o}><a href={`/user/${o}`}>{o}</a></li>)}
                    </ul>
                </div>
                {
                    this.state.sending && 'Sending...'
                }
                {
                    !this.state.sending &&
                    <Button variant="contained" color="secondary" onClick={this.onBack}>
                        Back to Edit
                    </Button>
                }
                {
                    valid && !this.state.sending &&
                    <Button variant="contained" color="primary" onClick={this.onMail}>
                        Mail
                    </Button>
                }
            </div>;
        }
        return (<div style={{ width: '100%' }}>
            {!valid && <div style={{ color: 'red' }}>{reason}</div>}
            <div>
                <h3>Mail Key</h3>
                <LazySelect value={this.state.key} onChange={this.onChangeMailKey} getOptions={this.loadEmailSelectOptions} />
                {
                    this.state.key &&
                    <MailContent mailKey={this.state.key.value} />
                }
            </div>
            <div>
                <h3>Reward Items</h3>
                <Button variant="contained" color="primary" onClick={this.addItem}>Add Item</Button>
                <table>
                    <tbody>
                        {
                            this.state.items.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ width: '500px' }}>
                                        <LazySelect value={item.key} onChange={this.onChangeItemKey(index)} getOptions={this.loadItemSelectOptions} />
                                    </td>

                                    <td><TextField
                                        label="Count"
                                        value={item.count}
                                        onChange={this.onChangeItemCount(index)}
                                        type="number"
                                    /></td>
                                    <td><Button variant="contained" color="primary" onClick={this.onDeleteItem(index)}>Delete</Button></td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
            <div>
                <h3>Other Users</h3>
                <textarea rows={5} cols={200} value={this.state.othersText} onChange={this.onChangeOthersText} />
            </div>
            {
                this.props.onClose &&
                <Button variant="contained" color="primary" onClick={this.onCancel}>
                    Cancel
                </Button>
            }
            <Button variant="contained" color="primary" onClick={this.onPreview}>
                Preview
            </Button>
        </div>);
    }
}

SendMail.propTypes = {
    userId: PropTypes.string.isRequired,
    onClose: PropTypes.func,
};

class Mails extends React.PureComponent {
    state = {
        loading: true,
        inventory: null,
        error: null,
        sending: false,
    }
    componentDidMount() {
        this.reload();
    }
    reload() {
        fetch(`/api/data/get/mails/${this.props.userId}`, { cache: 'no-cache' })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ loading: false, error: result.error });
                } else {
                    this.setState({ loading: false, inventory: result.result });
                }
            });
    }

    sendMail = () => {
        this.setState({ sending: true });
    }

    finishMail = () => {
        this.setState({ sending: false, loading: true });
        this.reload();
    }

    render() {
        if (this.state.loading) {
            return <div>Loading...</div>;
        }
        if (this.state.error) {
            return <div>{this.state.error}</div>;
        }
        if (!this.state.sending) {
            return (
                <div>
                    <pre>
                        {JSON.stringify(this.state.inventory, null, 4)}
                    </pre>
                    <Button variant="contained" color="primary" onClick={this.sendMail}>
                        Send Mail to this User
                    </Button>
                </div>
            );
        }
        return <SendMail userId={this.props.userId} onClose={this.finishMail} />;
    }
}

Mails.propTypes = {
    userId: PropTypes.string.isRequired,
};

export default class User extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = getStateFromHash().user || {
            tab: 0,
        };
        this.state.loading = true;
    }

    componentDidMount() {
        this.reload();
    }

    reload() {
        console.assert(this.state.loading);
        const userId = this.props.match.params.userId;
        fetch(`/api/data/get/user/${userId}`, { cache: 'no-cache' })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ loading: false, error: result.error });
                } else {
                    this.setState({ loading: false, data: result.result });
                }
            });
    }

    componentDidUpdate() {
        const data = getStateFromHash();
        data.user = this.state;
        setStateToHash(data);
    }

    setTab = (e, value) => {
        this.setState({ tab: value });
    }

    render() {
        const userId = this.props.match.params.userId;
        if (this.state.loading) {
            return 'Loading...';
        }
        const user = this.state.data;
        console.log('user', user);
        const tabs = [
            { label: "User", component: UserInfo },
            { label: "Inventory", component: Inventory },
            { label: "Cards", component: Cards },
            { label: "Mails", component: Mails },
            { label: "Achievement", component: Achievement },
            { label: "Map Event", component: MapEvent },
            { label: "Subscriptions", component: Subscriptions },
            { label: "Gacha", component: Gacha },
            { label: "In-App Purchase", component: InAppPurchase },
            { label: "Tournament Player States", component: TournamentPlayerStates },
            { label: "Map Comments", component: MapComments },
            { label: "User Backup Data", component: UserBackupData },
            { label: "Rpc Logs", component: RpcLogs },
        ];
        const TabComponent = tabs[this.state.tab].component;
        return (
            <div>
                <h1>User Id: {userId}</h1>
                {
                    user.deleted &&
                    <h2>This user account has been marked for deletion.</h2>
                }
                {
                    !user.deleted &&
                    <AppBar position="static">
                        <Tabs value={this.state.tab} onChange={this.setTab}
                            variant="scrollable" scrollButtons="auto">
                            {
                                tabs.map(tab => <Tab key={tab.label} label={tab.label} />)
                            }
                        </Tabs>
                    </AppBar>
                }
                {
                    !user.deleted &&
                    <TabComponent userId={userId} user={user} />
                }
            </div>
        );
    }
}

User.propTypes = {
    match: PropTypes.object.isRequired,
};
